import { connect } from 'react-redux'

import TypeColor from './TypeColor'

const mapStateToProps = state => ({
  configurator: state.configurator
})

const mapDispatchToProps = {}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TypeColor)
